import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {catchError,  map, switchMap, } from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import { SendBackResult} from '../../shared';
import {of} from 'rxjs';
import {EndBillingAction, EndBillingActionComplex, endBillingActionTypes, EndBillingFailAction, EndBillingSuccessAction} from '../actions/subscription-close';
import {CloseSubscriptionService} from '../services/close-subscription.service';
import {LoadSubAnomalyListAction, LoadSubByClientListAction, LoadSubListAction} from '../actions/subscription-list';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class CloseSubscriptionEffect extends BaseEffect {

  add$ = createEffect(() => { return this.actions$.pipe(
    ofType(endBillingActionTypes.END_BILLING),
    debug('end billing action received.'),
    map((action: EndBillingAction) => action.payload),
    switchMap((payload) =>  this.closeSubscriptionService.endBilling(payload.companyUuid, payload.contractUuid , payload.data, payload.comment).pipe(
      switchMap((data: SendBackResult<boolean>) => of( new EndBillingSuccessAction(data.data) , this.updateData() )),
      catchError(res => this.catchResponseError(res))))
  )});


  close$ = createEffect(() => { return this.actions$.pipe(
    ofType(endBillingActionTypes.END_BILLING_COMPLEX),
    debug('end billing action received.'),
    map((action: EndBillingActionComplex) => action.payload),
    switchMap((payload) =>  this.closeSubscriptionService.endBillingComplex(payload).pipe(
      switchMap((data: SendBackResult<boolean>) => of( new EndBillingSuccessAction(data.data) , this.updateData() )),
      catchError(res => this.catchResponseError(res))))
  )});


  addSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(endBillingActionTypes.END_BILLING_SUCCESS),
    debug('end billing success action received.'),
    switchMap((data) => [
      success(this.translation.translate('END_BILLING_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  )});


  addFail$ = createEffect(() => { return this.actions$.pipe(ofType(endBillingActionTypes.END_BILLING_FAIL),
    debug('A server error occurred while end billing.'),
    map((err: EndBillingFailAction) =>
      error(this.translation.translate('END_BILLING_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private closeSubscriptionService: CloseSubscriptionService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new EndBillingFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new EndBillingFailAction(response['error'].message);
  }
  updateData(): Action {
    if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
     return new LoadSubAnomalyListAction();
    } else  if (this.router.url.split('?')[0].split('/')[2] === 'sites') {
      return new LoadSubByClientListAction();
    } else {
      return new LoadSubListAction();
    }
  }
}
